/** Sitewide settings the owner sets in the admin area; every visitor may read them. */
export type SiteSettings = {
  access_requests_open: boolean;
  conversions_paused: boolean;
  banner: string;
  max_upload_mb: number;
  /** The slug of the plan new invites get unless one is chosen. */
  default_plan: string;
  /** Files this large need a full engine, never the front's small one. */
  big_file_mb: number;
  /** Power mode takes a whole engine only for files at least this large. */
  power_min_mb: number;
  credits_normal: number;
  credits_big_power: number;
  /** CAD running time allowed per task, 1 to 30 minutes. */
  job_deadline_minutes: number;
  /** Days a STEP upload is kept after its last use; its drawings stay. 0 keeps it. */
  step_retention_days: number;
  /** Days a PDF, DWG or DXF export is kept; 0 keeps them. */
  export_retention_days: number;
};

export async function fetchSiteSettings(): Promise<SiteSettings | null> {
  try {
    const response = await fetch("/api/site", { cache: "no-store" });
    return response.ok ? ((await response.json()) as SiteSettings) : null;
  } catch {
    return null;
  }
}
